import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import {default as firebase} from 'firebase';
import { LocalitiAuthService } from '../localiti-auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  constructor(public auth: LocalitiAuthService, private router: Router) { }
  private sub;
  async ngOnDestroy() {
    this.sub.unsubscribe();
  }
  async ngOnInit() {
    // this.sub = this.auth.user.subscribe(u => {
    //   if (u) {
    //     this.router.navigate(["/home"]);  
    //   }
    // })
    // if (await this.auth.user.toPromise()) {
    //   console.log("nav to login");
    //   this.router.navigate(["/login"]);
    // }
  }

  async loginWithGoogle() {
    const res = await this.auth.signInWithPopup(new firebase.auth.GoogleAuthProvider());
    if (res) {
      this.router.navigate(['']);
    }
  }

}
